;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

const AlertSvgIcon = ({ className, iconSrc, height, width }) => {
    return (
        <span
            className={cx('svg-icon', className)}
            style={{
                width,
                height,
            }}
        >
            <img src={`/images/icons/${iconSrc}.svg`} alt="" />
        </span>
    );
};

AlertSvgIcon.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    iconSrc: PropTypes.string.isRequired,
    width: PropTypes.string,
};

export default AlertSvgIcon;
